// Whether the current user may open the internal Monitor app.
//
// This mirrors the *necessary* condition the Monitor backend enforces
// (`verify_monitor_access` in mono/app/monitor.py): the email must be on an
// internal domain. The authoritative `can_view_monitor` flag is still checked
// server-side by Monitor itself, so this gate only controls whether we surface
// the Monitor entry points (sidebar tab, conversation "Open in Monitor" button)
// — never actual access. Keep it here as the single source of truth so those
// entry points can't drift apart.
export function canViewMonitor(email: string | null | undefined): boolean {
  return /@(gridspace\.com|goguava\.ai)$/.test(email ?? '');
}
